"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../helpers");
const paramKeys_1 = require("../paramKeys");
const params_1 = require("../params");
const buildHit = (tracker) => {
    const json = {};
    params_1.globalParams.map((c, d) => {
        if (d.shortKey) {
            let value = tracker.params.get(c);
            if (value !== undefined && value !== d.defaultValue) {
                if (typeof value === 'boolean') {
                    value = value ? 1 : 0;
                }
                if (d.shortKey === 'pp') {
                    // let pp be passed as an object
                    json[d.shortKey] = value;
                }
                else {
                    json[d.shortKey] = '' + value;
                }
            }
        }
    });
    helpers_1.default.trace(json);
    tracker.params.set(paramKeys_1.default.HitPayload, json, true);
};
exports.default = buildHit;
